import axios from 'axios';
import { REACT_APP_S3_BUCKET_PRESIGN_URL } from 'config/env';

export const getPresignedPostData = selectedFile => {
  return axios
    .post(REACT_APP_S3_BUCKET_PRESIGN_URL, {
      name: selectedFile.name,
      type: selectedFile.type
    })
    .then(res => res.data);
};
